import { render, staticRenderFns } from "./EditDate.vue?vue&type=template&id=23797746&scoped=true"
import script from "./EditDate.vue?vue&type=script&lang=ts"
export * from "./EditDate.vue?vue&type=script&lang=ts"
import style0 from "./EditDate.vue?vue&type=style&index=0&id=23797746&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23797746",
  null
  
)

export default component.exports